import FilterSectionHeader from './FilterSectionHeader';

export default FilterSectionHeader;
